export default "__VITE_ASSET__OpJFg$8V__"